
import Vue from "vue";
import { Prop } from "vue/types/options";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import {
  showVacancyText,
  showGreenFont,
  showOrangeFont,
  showGrayFont,
  showPinkFont,
  isHideVacancyCountText,
} from "@/usecase/vacancy";
import { showI18nTitle } from "@/usecase/language";
import portal from "@vacancorp/portal";
export default Vue.extend({
  name: "component-card-view-throne-vacancy",
  props: {
    vacancyStatus: {
      type: Object as Prop<PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined>,
      required: false,
      default: undefined,
      validator: (value) => {
        return value !== null && value !== undefined;
      },
    },
    inputData: {
      type: Object as Prop<portal.PublicPlaceWithVacancyId>,
      required: false,
    },
  },
  computed: {
    isHideVacancyCountText(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return isHideVacancyCountText(this.vacancyStatus);
    },
    isEnglish(): boolean {
      return this.$store.getters["data/getLanguageWithoutCountry"] === "en";
    },
    showVacancyText(): string {
      if (this.vacancyStatus === undefined) return "";
      return showVacancyText(this.vacancyStatus);
    },
    showGreenFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showGreenFont(this.vacancyStatus);
    },
    showOrangeFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showOrangeFont(this.vacancyStatus);
    },
    showGrayFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showGrayFont(this.vacancyStatus);
    },
    showPinkFont(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return showPinkFont(this.vacancyStatus);
    },
    showCongestionText(): string {
      if (!this.vacancyStatus || !this.vacancyStatus.availableCountTextI18n) return "";
      const result = showI18nTitle(this.vacancyStatus.availableCountTextI18n);
      return !result ? "" : result;
    },
    isEntryRestricted(): boolean {
      if (this.vacancyStatus === undefined) return false;
      return this.vacancyStatus.status === "entryRestricted";
    },
  },
  methods: {
    btnClicked() {
      this.$emit("btn-clicked");
    },
    helpClicked() {
      this.$emit("help-clicked");
    },
  },
});
